/* eslint-disable import/no-cycle */
import Contact from '@models/contact';
import CustomerLocation from '@models/customer-location';
import CustomerPurchaseOrder from '@models/customer-purchase-order';
import Invoices from '@models/invoice';
import Model from '@models/model';
import Order from '@models/order';

export const CUSTOMER_STATUS_CURRENT = 'Current';
export const CUSTOMER_STATUS_PAST_DUE = 'Past Due';
export const CUSTOMER_STATUS_ON_HOLD = 'On Hold';
export const CUSTOMER_STATUS_CANCELLED = 'Cancelled';
export const CUSTOMER_STATUS_WRITTEN_OFF = 'Written Off';

export const CUSTOMER_STATUSES = [
    { id: CUSTOMER_STATUS_CURRENT, text: CUSTOMER_STATUS_CURRENT },
    { id: CUSTOMER_STATUS_PAST_DUE, text: CUSTOMER_STATUS_PAST_DUE },
    { id: CUSTOMER_STATUS_ON_HOLD, text: CUSTOMER_STATUS_ON_HOLD },
    { id: CUSTOMER_STATUS_CANCELLED, text: CUSTOMER_STATUS_CANCELLED },
    { id: CUSTOMER_STATUS_WRITTEN_OFF, text: CUSTOMER_STATUS_WRITTEN_OFF },
];

export default class Customer extends Model {
    static className = 'Customer';

    invoices = [];

    index = true;

    yaypay = true;

    static allowsEdit = true;

    static allowedFieldEdits = [
        'billing_address_line_1',
        'billing_address_line_2',
        'billing_city',
        'billing_state',
        'billing_zip',
    ];

    relations() {
        return {
            invoices: Invoices,
        };
    }

    resource() {
        return 'customers';
    }

    purchaseOrders() {
        return this.hasMany(CustomerPurchaseOrder);
    }

    contacts() {
        return this.hasMany(Contact);
    }

    getOrders() {
        return this.hasMany(Order);
    }

    getLocations() {
        return this.hasMany(CustomerLocation);
    }

    get billingAddressFormatted() {
        if (!this.billing_address_line_1) return '';
        return `${this.billing_address_line_1}<br>
                ${this.billing_address_line_2 ? `${this.billing_address_line_2}<br>` : ''}
                ${this.billing_city}, ${this.billing_state} ${this.billing_zip}`;
    }

    static async getFinancials(customerId) {
        const response = await this.api().get(`/api/customers/${customerId}/financials`);

        return response.data;
    }

    get isOnHold() {
        return this.status === CUSTOMER_STATUS_ON_HOLD;
    }

    get isPastDue() {
        return this.status === CUSTOMER_STATUS_PAST_DUE;
    }
}
